/* eslint-disable */
import { get, post } from "../../network/endpoint"
import { dispatchHandler } from "../../utils/action"
import * as ActionTypes from "../action-types"
import { BFF } from "../../network/routes"
import _get from "lodash/get"

export function getMyCalls(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: queryParams,
      client: BFF,
      notAuthorization: true
    }

    const request = get("getCalls", config)

    return dispatch({
      type: ActionTypes.GET_CALLS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getInventarioDigital(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }
    const request = get("inventarioDigital", config)

    return dispatch({
      type: ActionTypes.GET_INVENTARIO_DIGITAL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function serviceTNCM1(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }
    const request = get("inventarioDigitalHostname", config)

    return dispatch({
      type: ActionTypes.GET_INVENTARIO_DIGITAL_HOSTNAME,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function serviceTNCM2(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("tncm2", config)

    return dispatch({
      type: ActionTypes.SERVICE_TNCM2,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function serviceTNCM3(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      useAccept: true
    }

    const request = get("tncm3", config)

    return dispatch({
      type: ActionTypes.SERVICE_TNCM3,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function serviceTNCM4(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      useAccept: true,
      contentXml: true
    }

    const request = get("tncm4", config)

    dispatch({
      type: ActionTypes.SERVICE_TNCM4,
      payload: request
    }).then((success) => {
      const data = _get(success, "payload.data", null)
      const searchData =
        data && (data.search("SUC-00001") || data.search("Ping falhou"))
      const finish = searchData === -1 ? false : true

      if (!finish) {
        serviceTNCM4(queryParams, callback, callbackFail)
      }

      if (finish) {
        Promise.all([dispatchHandler(callback, callbackFail)]).then((test) =>
          console.log("teste", test)
        )
      }
    })
  }
}

export function getProtocol(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("protocol", config)

    return dispatch({
      type: ActionTypes.GET_PROTOCOL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function openTicket(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("openTicket", config)

    return dispatch({
      type: ActionTypes.OPEN_TICKET,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getInteration(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("interaction", config)

    return dispatch({
      type: ActionTypes.GET_INTERACTION,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function addComments(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      data: queryParams,
      client: BFF,
      pathValues: queryParams
    }

    const request = post("addComments", config)

    return dispatch({
      type: ActionTypes.ADD_COMMENTS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function sendEmail(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      data: queryParams,
      client: BFF,
      pathValues: queryParams
    }

    const request = post("sendEmail", config)

    return dispatch({
      type: ActionTypes.SEND_MAIL_MY_CALLS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function closeOrder(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      data: queryParams,
      client: BFF,
      pathValues: queryParams
    }

    const request = post("closeOrder", config)

    return dispatch({
      type: ActionTypes.CLOSE_ORDER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getLastOrders(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      useAccept: true
    }

    const request = get("getLastOrders", config)

    return dispatch({
      type: ActionTypes.LAST_ORDERS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getVerifyCircuit(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }

    const request = get("getVerifyCircuit", config)

    return dispatch({
      type: ActionTypes.VERIFY_CIRCUIT,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function unblockingCircuit(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("unblockingCircuit", config)

    return dispatch({
      type: ActionTypes.UNBLOCKING_CIRCUIT,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getVerifyMassive(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }

    const request = get("getVerifyMassive", config)

    return dispatch({
      type: ActionTypes.VERIFY_MASSIVE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getVerifyCalled(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("getVerifyCalled", config)

    return dispatch({
      type: ActionTypes.VERIFY_CALLED,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getDetailProtocol(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }
    const request = get("getDetailProtocol", config)

    return dispatch({
      type: ActionTypes.GET_DETAIL_PROTOCOL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function algarInitialTest(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF,
      data: queryParams
    }
    const request = post("algarInitialTest", config)

    return dispatch({
      type: ActionTypes.ALGAR_INITIAL_TEST,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getAlgarVerifyTest(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      client: BFF
    }
    const request = get("getAlgarVerifyTest", config)

    return dispatch({
      type: ActionTypes.GET_ALGAR_VERIFY_TEST,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function preSchedule(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      data: queryParams,
      client: BFF,
      pathValues: queryParams
    }

    const request = post("preSchedule", config)

    return dispatch({
      type: ActionTypes.PRE_SCHEDULE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function preScheduleWindows(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      pathValues: queryParams,
      useAccept: true
    }

    const request = get("preScheduleWindows", config)

    return dispatch({
      type: ActionTypes.PRE_SCHEDULE_WINDOWS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function createLead(circuitId, payloadWorkLogs, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      useMock: false,
      data: payloadWorkLogs,
      client: BFF,
      pathValues: { circuitId }
    }

    const request = post("createLead", config)

    return dispatch({
      type: ActionTypes.CREATE_LEAD,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function attachFileOnOrder(payload, callback, callbackFail) {
  const { orderId, body, fileName } = payload
  return (dispatch) => {
    const config = {
      useMock: false,
      data: body,
      client: BFF,
      pathValues: { orderId },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.floor(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        dispatch({
          type: ActionTypes.ATTACHMENT_PROGRESS,
          progress: percentCompleted,
          fileName
        })
      }
    }

    const request = post("attachmentFileOnOrder", config)

    return dispatch({
      type: ActionTypes.ATTACHMENT,
      payload: request,
      fileName
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getWorkOrdersSOM(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF,
      data
    }
    const request = post("getWorkOrdersSOM", config)

    return dispatch({
      type: ActionTypes.WORK_ORDER_SOM,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getCommentsOrderSOM(payload, callback, callbackFail) {
  const { orderId, page, size } = payload

  return (dispatch) => {
    const config = {
      client: BFF,
      pathValues: { orderId, page, size }
    }
    const request = get("getCommentsOrderSOM", config)

    return dispatch({
      type: ActionTypes.COMMENTS_SOM,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getWorkOrderControlDesk(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF,
      data
    }
    const request = post("getWorkOrderControlDesk", config)

    return dispatch({
      type: ActionTypes.WORK_ORDER_CONTROL_DESK,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}
export function getCommentsControlDesk(data, callback, callbackFail) {
  const { orderId, page, size } = data

  return (dispatch) => {
    const config = {
      client: BFF,
      pathValues: { orderId, page, size }
    }
    const request = get("getCommentsControlDesk", config)

    return dispatch({
      type: ActionTypes.COMMENTS_CONTROL_DESK,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function createWorkOrderControlDesk(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      data,
      client: BFF
    }
    const request = post("createWorkOrderControlDesk", config)

    return dispatch({
      type: ActionTypes.CREATE_WORK_ORDER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getServiceCategory(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      data,
      client: BFF
    }
    const request = post("getServiceCategory", config)

    return dispatch({
      type: ActionTypes.WORK_ORDER_SERVICE_CATEGORY,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}
export function getTypeRequest(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      data,
      client: BFF
    }
    const request = post("getTypeRequest", config)

    return dispatch({
      type: ActionTypes.WORK_ORDER_TYPE_REQUEST,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getTypeDomains(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      data,
      client: BFF
    }
    const request = post("getTypeDomains", config)

    return dispatch({
      type: ActionTypes.WORK_ORDER_TYPE_DOMAIN,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/myCalls/action.js